import type { z } from "zod";
import type { historyCommentSchema, historyTrackListSchema, tracklistCommentSchema } from "./schemas";

export enum CommentRating {
	NEGATIVE = -1,
	NONE = 0,
	POSITIVE = 1,
}

export type HistoryTrackList = z.infer<typeof historyTrackListSchema>;
export type TracklistComment = z.infer<typeof tracklistCommentSchema>;
export type HistoryComment = z.infer<typeof historyCommentSchema>;
